import { StateCreator } from "zustand";
import {
  AuthSlice,
  MessageSlice,
  ThemeSlice,
  RegisterSlice,
  SectionSlice,
  OptionSlice,
  OrganizationSlice,
} from "../../interfaces";

export const createSectionSlice: StateCreator<
  RegisterSlice &
    SectionSlice &
    MessageSlice &
    AuthSlice &
    OptionSlice &
    OrganizationSlice &
    ThemeSlice,
  [["zustand/persist", unknown]],
  [],
  SectionSlice
> = (set: any, get: any) => {
  return {
    selectedSectionZustand: "",
    setSelectedSectionZustand(section) {
      set({
        selectedSectionZustand: section,
      });
    },
  };
};
